const formatDate = (isoDate) => {
    if (!isoDate) return '';
    const date = new Date(isoDate);
    return `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
};

export const handleClientTextFilter = (txtFiltro, datosOriginales) => {
    const inputBuscar = txtFiltro?.toUpperCase();
    return datosOriginales?.filter((tramo) => {
        const id = tramo?.id?.toString().toUpperCase();
        const fechaExpira = formatDate(tramo?.fechaExpira).toUpperCase();
        const descripcion = tramo?.descripcion?.toUpperCase();
        const valor = tramo?.valor?.toString()?.toUpperCase() || '';

        return (
            id?.includes(inputBuscar) ||
            fechaExpira?.includes(inputBuscar) ||
            descripcion?.includes(inputBuscar) ||
            valor?.includes(inputBuscar)
        );
    });
};